import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import { Form, Input, InputNumber, notification, Select } from 'antd'
import buttonStyles from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.js'
import Button from 'components/CustomButtons/Button.js'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import React, {useEffect, useRef, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { useHistory } from 'react-router-dom'
import {
  addNewGroupStates,
  fetchGroupStates,
  updateGroupState,
} from 'reduxToolkit/features/groupState/GroupStateSlice'
import { fetchUserGroups } from 'reduxToolkit/features/userGroups/UserGroupSlice'
import { updateAuthority } from '../../../../reduxToolkit/features/AccreditationAuthority/AuthoritySlice'
import ErrorModal from 'views/Components/ErrorModal'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
  },
}))

const useButtonStyles = makeStyles(buttonStyles)

const layout = {
  labelCol: {
    span: 5,
  },
  wrapperCol: {
    span: 18,
  },
}

const tailLayout = {
  wrapperCol: {
    offset: 12,
    span: 0,
  },
}

const EditAuthority = ({
  match,
  authority,
  ping,
  setPing,
  open,
  handleOpenEditModal,
  handleClose,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const buttonClasses = useButtonStyles()
  const [form] = Form.useForm()
  const anchorRef = useRef(null)

  const { Option, OptGroup } = Select
  const { TextArea } = Input

  const [group_ids, setGroups_ids] = useState('')
  const [name, setName] = useState('')
  const [addRequestStatus, setAddRequestStatus] = useState('idle')
  const [updateRequestStatus, setUpdateRequestStatus] = useState('idle')
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [handledError, setHandledError] = useState('')

  useEffect(() => {
    form.setFieldsValue({
      name: authority?.name,
      description: authority?.description,
    })
  }, [])

  const onFinish = async (values) => {
    try {
      const resultAction = await dispatch(
        updateAuthority({ ...values, id: authority.id }),
      )
      unwrapResult(resultAction)
      handleClose()
      setPing(!ping)
      openNotificationWithIcon('success', `update successfully`)
    } catch (err) {
      setHandledError(err)
      handleOpenErrorModal()
    }
  }

  const classes = useStyles()
  const onChange = (value) => {
    setName(value)
  }

  const history = useHistory()

  const stateNames = useSelector(
    (state) => state.ReportStates.ReportStatesConfigs,
  )

  const groupsList = useSelector((state) => state.userGroup.userGroups)

  const onChangeGroups_ids = (value) => {
    setGroups_ids(value)
  }

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false)
  }

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    })
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        <center> {t('Update Authority')}</center>
      </DialogTitle>
      <DialogContent style={{ width: '600px' }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Form
              {...layout}
              form={form}
              name="control-hooks"
              onFinish={onFinish}
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the name.',
                  },
                ]}
              >
                <Input maxLength={100} />
              </Form.Item>
              <Form.Item
                name="description"
                label="Description"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the description.',
                  },
                ]}
              >
                <TextArea rows={4} placeholder="description..." />
              </Form.Item>

              <Form.Item {...tailLayout}>
                <Button
                  style={{ marginRight: '20px' }}
                  color="danger"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button type="primary" color="info">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </Dialog>
  )
}

export default EditAuthority
